import React, { useCallback } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

interface ActionButtonsProps {
  fieldNo: string;
  item: any;
  verified: { [key: string]: boolean };
  editFieldValues: { [key: string]: any };
  editFiles: { [key: string]: File | null };
  fieldComments: { [key: string]: string };
  updatedIndexes: number[];
  onVerifiedChange: (fieldIndex: string) => void;
  onEditingToggle: (index: number) => void;
  onFieldSubmit: (index: number, item: any) => void;
  onCommentChange: (fieldName: string, comment: string) => void;
  editingIndex: number | null;
  pendingVerified: { [key: string]: boolean };
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  fieldNo,
  item,
  verified,
  editFieldValues,
  editFiles,
  pendingVerified,
  fieldComments,
  updatedIndexes,
  onVerifiedChange,
  onEditingToggle,
  onFieldSubmit,
  onCommentChange,
  editingIndex
}) => {
  const index = parseInt(fieldNo);

  // Get field status utility function
  const getFieldStatus = (index: number) => {
    const isVerified = verified[fieldNo]; // Use fieldNo instead of index
    const isUpdated = updatedIndexes.includes(index);

    return {
      isVerified,
      isUpdated
    };
  };

  const fieldStatus = getFieldStatus(index);

  // Check if any action has been taken for this specific field
  const isVerified = pendingVerified[fieldNo];
  
  // Check if there are any updates specific to this field
  const hasUpdatesForThisField = Object.keys(editFieldValues).some(key => 
    item.response?.some(response => response.responseVal === key)
  ) || Object.keys(editFiles).some(key => 
    item.response?.some(response => response.responseVal === key)
  );
  
  const hasComment = fieldComments[item.fieldName]?.trim();
  
  // Action is required if none of the conditions are met
  const actionRequired = !isVerified && !hasUpdatesForThisField && !hasComment;

  // Check if submit button should be enabled
  const isSubmitEnabled = isVerified || hasUpdatesForThisField || hasComment;

  const handleCommentChange = useCallback((e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onCommentChange(item.fieldName, e.target.value);
  }, [item.fieldName, onCommentChange]);

  return (
    <div className='d-flex w-100 flex-column justify-content-center align-items-center gap-2'>
      <div className="d-flex w-75 gap-2 flex-column flex-xl-row">
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="tooltip-update">Update</Tooltip>}
        >
          <button
            type="button"
            className={`btn ${fieldStatus.isUpdated ? 'btn-info' : 'btn-outline-info'} w-100`}
            onClick={() => onEditingToggle(editingIndex === index ? -1 : index)}
          >
            {fieldStatus.isUpdated ? "Updated" : "Update"}
          </button>
        </OverlayTrigger>
      </div>

      {/* <div className='w-75'>
        <button 
          className={`btn w-100 ${isSubmitEnabled ? 'btn-success' : 'btn-secondary'}`}
          onClick={() => onFieldSubmit(index, item?.response)}
          disabled={!isSubmitEnabled}
        >
          Submit
        </button>
      </div> */}

      {/* Action Required message when no action is taken */}
      {/* {actionRequired && (
        <p className="text-danger fw-semibold mt-1 mb-0 small">
          Action Required
        </p>
      )} */}
    </div>
  );
};

export default ActionButtons;